import { InGridToolBarButton } from "../editableGrid/editableGrid";
import React from "react";
export default class ToolBarFloatingButtons extends React.Component<{
    buttons: InGridToolBarButton[];
    onClick: (btn: InGridToolBarButton) => void;
}, {
    }> {
    private id = kendo.guid().toString();
    private floatingActionButton: kendo.ui.FloatingActionButton = null;

    constructor(props) {
        super(props);
    }

    private getItems = () => {
        return this.props.buttons.map(x => {
            return {
                cssClass: "toolbar-floating-button-wrapper",
                label: x.caption,
                icon: x.iconClass,
                click: (e: kendo.ui.FloatingActionButtonItemClickEvent) => {
                    this.props.onClick(x);
                },
                enabled: x.enabled(null),
                template: `
                    <span class='toolbar-floating-button__item-text k-fab-item-text'>${x.caption}</span>
                    <span class='toolbar-floating-button__item-icon k-fab-item-icon ${x.iconClass.startsWith("k-") ? "k-icon " + x.iconClass : x.iconClass}'></span>
                `
            }
        });
    }

    componentDidMount() {
        let options = this.getOptions();
        this.floatingActionButton = $("#toolBarFloatingButtons_" + this.id)
            .kendoFloatingActionButton(options)
            .data("kendoFloatingActionButton");
    }

    private getOptions = (): kendo.ui.FloatingActionButtonOptions => {
        let options: kendo.ui.FloatingActionButtonOptions = {
            size: "medium",
            items: this.getItems(),
            expand: () => this.setState({}),
            collapse: () => this.setState({}),
            align: "bottom end",
            positionMode: "absolute"
        }

        if (this.props.buttons.length == 1) {
            options.items = [];
            options.click = (e) => {
                e.preventDefault();
                this.props.onClick(this.props.buttons[0]);
            };
            options.enabled = this.props.buttons[0].enabled(null);
        }

        return options;
    }

    componentDidUpdate(prevProps) {
        if (this.floatingActionButton && this.props.buttons != prevProps.buttons) {
            let enabled = this.floatingActionButton.options.enabled;
            if (this.props.buttons.length == 1)
                enabled = this.props.buttons[0].enabled(null);

            this.floatingActionButton.setOptions({
                items: this.getItems(),
                enabled: enabled
            });
        }
    }

    private getIcon = () => {
        let icon: any = "k-i-plus";
        if (this.props.buttons.length == 1) {
            icon = this.props.buttons[0].iconClass
        } else if (this.floatingActionButton) {
            if (this.floatingActionButton.element.attr("aria-expanded") == "true")
                icon += " k-rotate-45";
        }

        return icon;
    }

    render() {
        if (!this.props.buttons || this.props.buttons.length <= 0)
            return null;

        let icon = this.getIcon();
        return <button id={"toolBarFloatingButtons_" + this.id} className="toolbar-floating-button">
            <i className={icon.startsWith("k-") ? "k-icon " + icon : icon} style={{ fontSize: "24px" }}></i>
        </button>
    }
}